import {isString} from '@malt/common';

export class PopoverController {
    constructor(root, params = {}) {
        this._root = root;
        this._params = params;

        this._parentNode = root.parentNode;
        this._allStepsContent = root.querySelectorAll('.c-popover_main-content');
        this._indicators = root.querySelectorAll('.js-indicators__dot');
        this._nextStepCta = root.querySelector('.js-popover_cta');
        this._closeBtn = root.querySelector('.js-close-btn');
        this._currentStepIndex = 1;
        this._opener = this._getOpener();

        this._displayPopover = this._displayPopover.bind(this);
        this._nextStep = this._nextStep.bind(this);
        this._triggerIndicatorNavigation = this._triggerIndicatorNavigation.bind(this);
        this._closePopover = this._closePopover.bind(this);
    }

    _getOpener() {
        if (this._params.opener) {
            if (isString(this._params.opener)) {
                return document.querySelector(`.${this._params.opener}`);
            } else {
                return this._params.opener; // If it's an HTMLelement
            }
        }
        return null;
    }

    _indicatorStepUpdate(clickedIndicatorIndex) {
        const currentStepContent = this._root.querySelector(`[data-current-step='${this._currentStepIndex}']`);
        const currentStepIndicator = this._root.querySelector('.js-indicators__dot.active');

        const newStepContent = this._root.querySelector(`[data-current-step='${clickedIndicatorIndex}']`);
        const newStepIndicator = this._root.querySelector(`[data-index='${clickedIndicatorIndex}']`);

        this._currentStepIndex = clickedIndicatorIndex;

        this._removeActiveState(currentStepContent, currentStepIndicator);
        this._addActiveState(newStepIndicator, newStepContent);

        if (this._isLastStep(this._currentStepIndex)) {
            this._changeCtaLabel();
        } else {
            this._initialCtaLabel();
        }
    }

    _triggerIndicatorNavigation(e) {
        const activeIndicator = Number(e.target.getAttribute('data-index'));
        this._indicatorStepUpdate(activeIndicator);
    }

    _nextStep() {
        if (!this._isLastStep(this._currentStepIndex)) {
            const newStepContent = this._root.querySelector(`[data-current-step='${this._currentStepIndex + 1}']`);
            const currentStepContent = this._root.querySelector(`[data-current-step='${this._currentStepIndex}']`);

            const newStepIndicator = this._root.querySelector(`[data-index='${this._currentStepIndex + 1}']`);
            const currentStepIndicator = this._root.querySelector(`[data-index='${this._currentStepIndex}']`);

            this._currentStepIndex = Number(newStepContent.getAttribute('data-current-step'));

            this._removeActiveState(currentStepIndicator, currentStepContent);
            this._addActiveState(newStepIndicator, newStepContent);

            if (this._isLastStep(this._currentStepIndex)) {
                this._changeCtaLabel();
            }
        } else {
            this._closePopover();
        }
    }

    _changeCtaLabel() {
        this._nextStepCta.innerHTML = this._params.lastStepCtaLabel;
    }

    _initialCtaLabel() {
        this._nextStepCta.innerHTML = this._params.nextCtaLabel;
    }

    _isLastStep(stepIndex) {
        return stepIndex === this._allStepsContent.length;
    }

    _removeActiveState(...elements) {
        elements.forEach((el) => {
            el.classList.remove('active');
        });
    }

    _addActiveState(...elements) {
        elements.forEach((el) => {
            el.classList.add('active');
        });
    }

    _closePopover() {
        this._parentNode.classList.remove('active-popover');
        this._root.remove();
        this._root.dispatchEvent(
            new CustomEvent('close', {
                detail: {name: this._params.name},
            }),
        );
    }

    _displayPopover() {
        this._parentNode.classList.add('active-popover');
        this._root.classList.add('show-popover');
    }

    initialize() {
        if (this._opener) {
            this._opener.addEventListener('click', this._displayPopover);
        } else {
            this._displayPopover();
        }

        if (this._nextStepCta) {
            this._nextStepCta.addEventListener('click', this._nextStep);
        }

        if (this._indicators) {
            this._indicators.forEach((indicator) => {
                indicator.addEventListener('click', this._triggerIndicatorNavigation);
            });
        }

        this._closeBtn.addEventListener('click', this._closePopover);
    }

    destroy() {
        if (this._opener) {
            this._opener.removeEventListener('click', this._displayPopover);
        }

        if (this._nextStepCta) {
            this._nextStepCta.removeEventListener('click', this._nextStep);
        }

        this._indicators.forEach((indicator) => {
            indicator.removeEventListener('click', this._triggerIndicatorNavigation);
        });

        this._closeBtn.removeEventListener('click', this._closePopover);
    }
}
